import React, { forwardRef } from 'react';

import MediaQuery from './media-query';

/**
 * @type {React.FC<PropsWithChildren<{
 *  mediaQuery?: string;
 *  direction?: string;
 *  children?: Element;
 * }>>}
 */
const DesktopOnly = forwardRef(({ children, mediaQuery = 'md', ...otherProps }, ref) => (
  <MediaQuery ref={ref} mediaQuery={mediaQuery} {...otherProps} direction='up'>
    {children}
  </MediaQuery>
));
DesktopOnly.snapshot = false;

export default DesktopOnly;
